import { User, Globe } from 'lucide-react';
import { FormField, TextInput, SelectInput } from '../form-fields';
import { countries } from '../form-data/formOptions';
import { UserInfoFormData } from '../hooks/useUserInfoForm';

interface Step1PersonalInfoProps {
  formData: UserInfoFormData;
  loading: boolean;
  updateField: (field: keyof UserInfoFormData, value: string) => void;
}

export function Step1PersonalInfo({ formData, loading, updateField }: Step1PersonalInfoProps) {
  return (
    <div className="space-y-4">
      {/* Step Header */}
      <div className="text-center">
        <h2 className="text-lg font-medium text-theme-light-text-primary dark:text-theme-dark-text-primary mb-1">
          Personal Information
        </h2>
        <p className="text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary">
          Let's start with your basic information
        </p>
      </div>

      {/* Form Fields */}
      <div className="space-y-4">
        {/* Display Name Field */}
        <FormField label="Display Name" htmlFor="displayName" required>
          <TextInput
            id="displayName"
            name="displayName"
            placeholder="Enter your full name"
            value={formData.displayName}
            onChange={(e) => updateField('displayName', e.target.value)}
            disabled={loading}
            required
            icon={User}
          />
        </FormField>

        {/* Country Field */}
        <FormField label="Country" htmlFor="country" required>
          <SelectInput
            id="country"
            name="country"
            placeholder="Select your country"
            value={formData.country}
            onChange={(e) => updateField('country', e.target.value)}
            options={countries}
            disabled={loading}
            required
            icon={Globe}
          />
        </FormField>
      </div>
    </div>
  );
}
